import { BrandColors, WorkflowItemCode } from '../../constants';
import { TaskListConfiguration } from '../interfaces';

export const taskListDefaultConfiguration: TaskListConfiguration = {
  sequential: true,
  linearflow: false,
  showTaskList: true,
  surveyEnabled: false,
  surveyTriggerCode: '',
  endPage: {
    backgroundColor: '#5B6770',
    backgroundImage: null,
    bannerImageEnabled: true,
    contentPenultimate:
      '<h2>This is Not Completed End Page</h2><p><span style="background-color:rgb(255,255,255);color:rgb(0,0,0);">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which do not look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there is not anything embarrassing hidden in the middle of text.</span></p>',
    bannerImage: null,
    content:
      "<h1 style='text-align:center;'>AT SHL WE SPEAK UP AND STAND OUT</h1><p style='text-align:justify;'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>",
    nextStepLabel: 'Next Steps',
    nextStepLabelColor: BrandColors.green57,
    completedTasksLabel: 'Done',
    completedTasksLabelColor: BrandColors.green57,
    optionalTasksLabel: 'Unlocked',
    optionalTasksLabelColor: BrandColors.green57,
    enableNextSteps: true,
    surveyEnabled: false,
    surveyTriggerCode: '',
    surveyEnabledPenultimate: false,
    surveyTriggerCodePenultimate: '',
    timeline: {
      iconColor: BrandColors.green25,
      iconContainerColor: BrandColors.grey15,
      lineColor: BrandColors.green25,
    },
    links: [
      {
        title: 'link0',
        url: 'https://www.shl.com/',
        description: `It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy.`,
        buttonText: 'Go',
      },
      {
        title: 'link1',
        url: 'https://www.shl.com/',
        description: `It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy.`,
        buttonText: 'Go',
      },
      {
        title: 'link2',
        url: 'https://www.shl.com/',
        description: `It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy.`,
        buttonText: 'Go',
      },
    ],
  },
  hurdlePage: {
    backgroundColor: null,
    backgroundImage: {
      name: 'image',
      path: 'https://images.pexels.com/photos/1524105/pexels-photo-1524105.jpeg?cs=srgb&dl=three-women-posing-for-photo-1524105.jpg&fm=jpg',
      uuid: '',
    },
    bannerImageEnabled: false,
    bannerImage: null,
    content: '',
    nextStepLabel: 'Whats Now',
    nextStepLabelColor: BrandColors.green57,
    surveyEnabled: false,
    surveyTriggerCode: '',
    links: [
      {
        title: 'link0',
        url: 'https://www.shl.com/',
        description: `It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy.`,
        buttonText: 'Go',
      },
      {
        title: 'link1',
        url: 'https://www.shl.com/',
        description: `It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy.`,
        buttonText: 'Go',
      },
      {
        title: 'link2',
        url: 'https://www.shl.com/',
        description: `It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy.`,
        buttonText: 'Go',
      },
    ],
  },
  manualHurdlePage: {
    backgroundColor: null,
    backgroundImage: {
      name: 'image',
      path: 'https://images.pexels.com/photos/1524105/pexels-photo-1524105.jpeg?cs=srgb&dl=three-women-posing-for-photo-1524105.jpg&fm=jpg',
      uuid: '',
    },
    bannerImageEnabled: false,
    bannerImage: null,
    content: '',
    surveyEnabled: false,
    surveyTriggerCode: '',
  },
  styles: {
    bannerImageEnabled: true,
    bannerImage: null,
    backgroundColor: BrandColors.white,
    content:
      "<h1 style='text-align:center;'>AT SHL WE SPEAK UP AND STAND OUT</h1><p style='text-align:justify;'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>",
    label: 'To Do',
    backgroundImageEnabled: false,
    backgroundImage: null,
    taskContainerColor: BrandColors.white,
    taskListLabelAndDescriptionColor: BrandColors.grey15,
    opacity: 100,
    taskListDescription: 'Here your tasks for today',
    labelColor: BrandColors.green57,
    tiles: {
      backgroundColor: BrandColors.white,
      textColor: BrandColors.grey15,
      bannerColor: BrandColors.green57,
      bannerTextColor: BrandColors.grey35,
      iconColor: BrandColors.green57,
      progressBarColor: BrandColors.green57,
      startButtonColor: BrandColors.green25,
      startButtonTextColor: BrandColors.white,
      startButtonText: 'Start',
    },
    progressBar: {
      dotColor: BrandColors.green25,
      fillColor: BrandColors.white,
      outlineColor: BrandColors.green25,
    },
    timeline: {
      iconColor: BrandColors.green25,
      iconContainerColor: BrandColors.grey15,
      lineColor: BrandColors.green25,
    },
  },
  feedbackPage: {
    enabled: true,
    cfc: 0,
    backgroundColor: BrandColors.white,
    contentContainerColor: BrandColors.white,
    contentContainerOpacity: '100',
    content: '',
    buttonStyle: 'STYLE_1',
    buttonText: 'Go Back',
    buttonLink: 'https://',
    buttonLinkText: 'Return To Tasklist',
    buttonLinkStyle: 'STYLE_1',
    surveyEnabled: false,
    surveyTriggerCode: '',
  },
  tasks: [
    {
      id: 1,
      title: 'Learn More about SHL',
      subtitle: 'Informational Page',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Malesuada fames ac turpis egestas integer.',
      bannerColor: BrandColors.white,
      bannerImageEnabled: true,
      bannerImage: null,
      duration: 0,
      visibility: true,
      items: [
        { id: '10', code: WorkflowItemCode.EXPASSES },
        { id: '11', code: WorkflowItemCode.GENCONTENT },
        { id: '12', code: WorkflowItemCode.GENCONTENT },
      ],
    },
    {
      id: 2,
      title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit consectetur adipiscing elit',
      subtitle: 'tasklist1_subtitle',
      description: 'tasklist1_description',
      bannerColor: BrandColors.lightGrey40,
      bannerImageEnabled: false,
      bannerImage: null,
      duration: 0,
      visibility: true,
      items: [
        { id: '21', code: WorkflowItemCode.GENCONTENT },
        { id: '22', code: WorkflowItemCode.GENCONTENT },
      ],
    },
    {
      id: 3,
      title: 'tasklist2_title',
      subtitle: 'tasklist2_subtitle',
      description: 'tasklist2_description',
      bannerColor: BrandColors.white,
      bannerImageEnabled: true,
      bannerImage: null,
      duration: 3,
      visibility: true,
      items: [
        { id: '31', code: WorkflowItemCode.GENCONTENT },
        { id: '32', code: WorkflowItemCode.GENCONTENT },
      ],
    },
    {
      id: 4,
      title: 'tasklist4_title',
      bannerImageEnabled: false,
      bannerImage: null,
      duration: 0,
      visibility: true,
      items: [{ id: '41', code: WorkflowItemCode.GENCONTENT }],
    },
    {
      id: 5,
      title: 'tasklist5_title',
      bannerImageEnabled: false,
      bannerImage: null,
      duration: 0,
      visibility: true,
      items: [
        { id: '51', code: WorkflowItemCode.GENCONTENT },
        { id: '52', code: WorkflowItemCode.GENCONTENT },
      ],
    },
  ],
};
